export default "__VITE_ASSET__Ci68vCjd__"